import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb949620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asad-dowling" }
const _hoisted_2 = {
  key: 0,
  class: "card-section"
}
const _hoisted_3 = { class: "container-1200 w-container" }
const _hoisted_4 = { class: "card-grid-container" }
const _hoisted_5 = {
  id: "member-1",
  class: "card-member"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "card-section"
}
const _hoisted_8 = { class: "container-1200 w-container" }
const _hoisted_9 = { class: "card-grid-container" }
const _hoisted_10 = {
  id: "select-member",
  class: "card-member"
}
const _hoisted_11 = { class: "card-description" }
const _hoisted_12 = { class: "select-person-wrapper" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "select-person-label" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.5V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-112.214 23.558-215.066-32.579-215.066-138.72 0-49.914 19.466-95.692 59.144-130.274-47.106-5.682-89.397-29.72-112.813-70.66 5.782.665 11.362 1.399 17.062 1.399 7.223 0 14.394-.856 21.62-2.499-49.944-9.988-86.348-51.284-86.348-101.91 0-53.417 42.998-96.638 96.638-96.638 30.303 0 57.534 12.061 76.323 31.585 20.964-4.578 41.903-13.319 61.478-25.34-13.462 24.122-35.54 45.868-62.695 57.57 21.902-2.383 43.18-8.122 62.095-16.23-14.588 20.699-34.802 35.732-57.69 42.462z"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.selectedPerson != null)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.selectedPerson != null && _ctx.selectedPersonHelloText != '')
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: _ctx.selectedPersonId,
                      class: "header"
                    }, _toDisplayString(_ctx.selectedPersonHelloText), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.selectedPerson != null && _ctx.selectedPersonImage != '')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: _ctx.selectedPersonId,
                          class: "card-image-wrapper"
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.selectedPersonImage,
                            class: "card-image"
                          }, null, 8, _hoisted_6)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPersonName != '')
                      ? (_openBlock(), _createElementBlock("h3", {
                          key: _ctx.selectedPersonId,
                          class: "card-heading"
                        }, _toDisplayString(_ctx.selectedPersonName), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPerson != null && _ctx.selectedPersonIntroParagraphs)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: _ctx.selectedPersonId,
                          class: "card-description"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPersonIntroParagraphs, (paragraph, i) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: `entry-${i}`
                            }, _toDisplayString(paragraph), 1))
                          }), 128)),
                          _createElementVNode("p", {
                            class: "unselect-person",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unselectPerson()))
                          }, "Head back")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.selectedPerson == null)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (person, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `person${index}`,
                        onClick: ($event: any) => (_ctx.selectPerson(person.id)),
                        class: "select-person"
                      }, [
                        _createElementVNode("img", {
                          class: "select-person-image",
                          src: person.image
                        }, null, 8, _hoisted_14),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getFirstNameOnly(person.name)), 1)
                      ], 8, _hoisted_13))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.selectedPerson != null && _ctx.selectedPersonEmail != '')
          ? (_openBlock(), _createElementBlock("section", {
              id: "email-section",
              key: _ctx.selectedPersonId,
              class: "email-section"
            }, [
              _createElementVNode("a", {
                id: "email-address",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyEmailAddress())),
                href: "#"
              }, _toDisplayString(_ctx.selectedPersonEmail), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.selectedPerson != null)
          ? (_openBlock(), _createElementBlock("section", {
              key: _ctx.selectedPersonId,
              id: "social-section",
              class: "social-section"
            }, [
              (_ctx.selectedPersonLinkedInUrl != '')
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openUrl(_ctx.selectedPersonLinkedInUrl))),
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fab",
                    "data-icon": "linkedin",
                    class: "svg-inline--fa fa-linkedin fa-w-14",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512"
                  }, _hoisted_17))
                : _createCommentVNode("", true),
              (_ctx.selectedPersonTwitterUrl != '')
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openUrl(_ctx.selectedPersonTwitterUrl))),
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fab",
                    "data-icon": "twitter",
                    class: "svg-inline--fa fa-twitter fa-w-16",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512"
                  }, _hoisted_19))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}